import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { ClientPolicyParticipants } from '@models/swagger';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';

export interface ParticipantsParams extends DefaultHttpHeaders {
  userId: string;
}

@Injectable()
export class ParticipantsService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  /**
   * Retrieve policy participants related to the user
   * Retrieve policy participants related to the user
   * https://d2go64w4712gob.cloudfront.net/swagger/apis_trasversales/italia/api_Verti.html#/Application%20Utilities/getPolicyParticipants
   */
  participants(params: ParticipantsParams): Observable<ClientPolicyParticipants[]> {
    const pathParams = {
      userId: params.userId,
    };
    return this.get<ClientPolicyParticipants[]>({
      suffix: `/comeround/applicationUtilities/user/${pathParams.userId}/policies/participants`,
      authenticationType: 'jwt',
    });
  }
}
